const API_BASE_URL = `${import.meta.env.REACT_APP_API_URL}`;

//
// Okta Related Endpoints
//
const GET_CONFIGURATION_OKTA = `${API_BASE_URL}/configuration/okta`;
const GET_OKTA_LOGIN = `${GET_CONFIGURATION_OKTA}/login`;

//
// Constants used in construction of other endpoints
//
const GET_COMMERCIAL_LINES = '/commercial-lines';
const GET_PAYMENTS_DUE_URL = '/payments-due';
const GET_PERSONAL_LINES = '/personal-lines';

//
// Utility Endpoints
//
const GET_ALL_AGENTS = `${API_BASE_URL}/agent/search`;
const GET_ALLOWED_AGENCY_CODES = `${API_BASE_URL}/agent/allowed-agent-codes`;
const GET_AGENCY_HAS_MSA_ACCESS = `${API_BASE_URL}/agent/has-msa-access`;
const GET_ANNOUNCEMENTS = `${API_BASE_URL}/announcements`;
const GET_ANNOUNCEMENTS_ITEM = `${GET_ANNOUNCEMENTS}/item`;
const GET_ANNOUNCEMENTS_ITEMS = `${GET_ANNOUNCEMENTS}/items`;
const GET_ANNOUNCEMENTS_MONTHS = `${GET_ANNOUNCEMENTS}/selection-months`;
const GET_ANNOUNCEMENTS_PRODUCTS = `${GET_ANNOUNCEMENTS}/selection-products`;
const GET_ANNOUNCEMENTS_STATES = `${GET_ANNOUNCEMENTS}/selection-states`;
const GET_ANNOUNCEMENTS_YEARS = `${GET_ANNOUNCEMENTS}/selection-years`;
const GET_DASHBOARD = `${API_BASE_URL}/dashboard`;
const GET_DASHBOARD_OPEN_CLAIMS = `${GET_DASHBOARD}/open-claims`;
const GET_DASHBOARD_RENEWALS = `${GET_DASHBOARD}/upcoming-renewals`;
const GET_DASHBOARD_OVERDUE_PAYMENTS = `${GET_DASHBOARD}/overdue-payments`;
const GET_DASHBOARD_UNSOLD_QUOTES = `${GET_DASHBOARD}/unsold-quotes-init`;
const GET_DASHBOARD_UNSOLD_QUOTES_STATUS = `${GET_DASHBOARD}/unsold-quotes-status`;
const GET_NEWS = `${API_BASE_URL}/news`;
const NEWS_ARTICLES = '/article';
const ALL_STATES_FOR_NEWS = `${GET_NEWS}/all-states`;
const ADD_TEXT_NEWS = `${GET_NEWS}/add-text-article`;
const ADD_DOC_NEWS = `${GET_NEWS}/add-document-article`;
const GET_NEWS_ARTICLES = `${GET_NEWS}/articles`;
const UPDATE_DOC_ARTICLE = `${GET_NEWS}/update-document-article`;
const UPDATE_TEXT_ARTICLE = `${GET_NEWS}/update-text-article`;
const DELETE_ARTICLE = `${GET_NEWS}/delete-article`;

//
// Generic Redirect Endpoints
//
const GET_REDIRECT_URL = `${API_BASE_URL}/redirectUrl`;

//
// Admin Endpoints
//
const ADMIN_CHANGE_HISTORY_SEARCH = `${API_BASE_URL}/adm/change-history/search`;
const ADMIN_MANAGE_RESOURCES = `${API_BASE_URL}/adm/manage-resources`;
const ADMIN_REGIONAL_CONTACTS = `${API_BASE_URL}/adm/regional-contacts`;

//
// Agency Admin Endpoints
//
const AGENCY_ADMIN_BASE_URL = `${API_BASE_URL}/agencyadm`;
const AGENCY_ADMIN_SEARCH = `${AGENCY_ADMIN_BASE_URL}/search`;
const AGENCY_ADMIN_GET_CURRENT_AGENCIES = `${AGENCY_ADMIN_BASE_URL}/current-agencies`;
const AGENCY_ADMIN_GET_AVAILABLE_AGENCIES = `${AGENCY_ADMIN_BASE_URL}/available-for-user`;
const AGENCY_ADMIN_GET_POTENTIAL_AGENCIES = `${AGENCY_ADMIN_BASE_URL}/potential-agencies`;
const AGENCY_ADMIN_GET_SELECTED_AGENCIES = `${AGENCY_ADMIN_BASE_URL}/selected-for-user`;
const AGENCY_ADMIN_ADD = `${AGENCY_ADMIN_BASE_URL}/add`;
const AGENCY_ADMIN_PUT_ADD_REMOVE = `${AGENCY_ADMIN_BASE_URL}/add-remove`;
const AGENCY_ADMIN_REMOVE = `${AGENCY_ADMIN_BASE_URL}/remove`;

//
// Appetite Endpoints
//
const GET_APPETITE = `${API_BASE_URL}/appetite`;
const GET_APPETITE_HEALTH_CHECK = `${GET_APPETITE}/healthCheck`;
const GET_APPETITE_STATES = `${GET_APPETITE}/states`;

//
// Health Check Endpoints
//
const AOC_API_HEALTH_CHECK_URL = `${API_BASE_URL}/healthcheck`;
const AOC_API_HEALTH_CHECK_LIST_URL = `${AOC_API_HEALTH_CHECK_URL}/list`;
const AOC_API_HEALTH_CHECK_INITIATE_URL = `${AOC_API_HEALTH_CHECK_URL}/initiate`;

//
// Autocomplete / Typeahead endpoints
//
const GET_PL_AUTO_COMPLETION_POLICY_ONE_SHIELD = `${API_BASE_URL}/typeahead${GET_PERSONAL_LINES}/policy-one-shield/`;

//
// Billing Endpoints
//
const GET_BILLING_DETAILS = `${API_BASE_URL}/billing/details`;
const GET_BILLING_EXACT_SEARCH = `${API_BASE_URL}/billing/exact-search`;
const GET_BILLING_SEARCH = `${API_BASE_URL}/billing/search`;
const GET_BILLING_SEARCH_PAGE_COUNT = `${API_BASE_URL}/billing/count-by`;
const POST_BILLING_PAYMENT = `${API_BASE_URL}/billing/payment`;
const GET_BILLING_PAYMENT = `${API_BASE_URL}/billing/payment`;
const GET_BILLING_PAYMENT_ADJUSTABLE_PAYMENTS = `${GET_BILLING_PAYMENT}/adjustable-payments`;
const GET_BILLING_PAYMENT_ACCOUNTS = `${GET_BILLING_PAYMENT}/payment-accounts`;
const POST_BILLING_PAYMENT_POST_PAYMENTS = `${POST_BILLING_PAYMENT}/post-payments`;
const GET_BILLING_PAYMENT_NSF_PAYMENTS = `${GET_BILLING_PAYMENT}/nsf-payments`;
const POST_BILLING_PAYMENT_ADJUST_PAYMENT = `${POST_BILLING_PAYMENT}/adjust-payment`;
const POST_BILLING_PAYMENT_REVERSE_PAYMENT = `${POST_BILLING_PAYMENT}/reverse-payment`;
const GET_BILLING_SEARCH_SUGGESTIONS = `${API_BASE_URL}/billing/auto-completion`;
const POLICY_NUMBER_SEARCH = `${API_BASE_URL}/policies`;
const GET_POLICY_NUMBER_SEARCH = `${POLICY_NUMBER_SEARCH}/policy-number`;

const GET_BILLING_SEARCH_V2 = `${API_BASE_URL}/billing/search-v2`;
//
// Billing Constaπts
//
const ACCOUNT_NUMBER_URL = '/account-number';
const INSURED_LAST_NAME_URL = '/insured-last-name';
const INSURED_LAST_NAME_COUNT_URL = '/insured-last-name-count';
const POLICY_NUMBER_URL = '/policy-number';

//
// BrandFolder
//
const BRANDFOLDER_BASE = `${API_BASE_URL}/brandfolder`;
const BRANDFOLDER_DOCS_PER_PAGE = `${BRANDFOLDER_BASE}/limits/documents_per_page`;
const BRANDFOLDER_SEARCH = `${BRANDFOLDER_BASE}/search`;
const BRANDFOLDER_VALIDATIONS = `${BRANDFOLDER_BASE}/validations`;
const BRANDFOLDER_ORDER_ASSETS = `${BRANDFOLDER_BASE}/order_assets`;

//
// Commerical Lines Endpoints
//
const GET_CL_RENEWALS_BASE = `${API_BASE_URL}/cls/renewals`;
const GET_CL_RENEWALS_DOCUMENTS = `${GET_CL_RENEWALS_BASE}/document-list`;
const GET_CL_RENEWALS_LOCATION_THRESHOLD = `${GET_CL_RENEWALS_BASE}/get-locations-threshold`;
const GET_CL_WIP_PRODUCT_LINES_URL = `${API_BASE_URL}/work-in-progress/product-lines${GET_COMMERCIAL_LINES}`;
const GET_CL_WIP_BASE_URL = `${API_BASE_URL}/work-in-progress/query?lineOfBusiness=commercial&vendorSystem=false`;
const GET_TRANSACTIONS_URL = `${API_BASE_URL}/transactions`;

//
// Clients List
//
const GET_CLIENTS = `${API_BASE_URL}/client-list`;
const GET_CLIENTS_ACCOUNTS = `${GET_CLIENTS}/clients`;
const GET_CLIENTS_LOBS = `${GET_CLIENTS}/lobs`;
const GET_CLIENTS_PRODUCTS = `${GET_CLIENTS}/products`;

//
// File and PDF Download Endpoints
//
const GET_DOWNLOAD_MEDIA = `${API_BASE_URL}/documents`;

//
// Personal Lines Endpoints
//
const GET_PL_POLICIES_ON_NAME = `${API_BASE_URL}/policy-inquiry/insured-last-name/personal-lines`;

//
// Policy Inquiry Endpoints
//
const GET_INQUIRE_MSE_POLICY = `${API_BASE_URL}/policy-inquiry/main-street-express`;
const GET_INQUIRE_MSS_POLICY = `${API_BASE_URL}/policy-inquiry/main-street-station`;

//
// Session Endpoints
//
const SESSION_URL = `${API_BASE_URL}/session`;

//
// Report Endpoints
//
const GET_REPORTS_URL = `${API_BASE_URL}/reports`;
const GET_AGENCY_SUGGESTIONS = `${GET_REPORTS_URL}/agencies/agency-suggestions`;
const GET_PERM_AGENCIES = `${GET_REPORTS_URL}/agencies/perm-agencies`;
const GET_ABS_URL = `${GET_REPORTS_URL}/agency-billed`;
const GET_ABS_REPORT_AGENTS = `${GET_ABS_URL}/agents`;
const GET_ABS_REPORT_DATES = `${GET_ABS_URL}/dates`;
const GET_APNE_URL = `${GET_REPORTS_URL}/apne`;
const GET_BMR_URL = `${GET_REPORTS_URL}/book-management`;
const GET_DBC_URL = `${GET_REPORTS_URL}/direct-bill-commission`;
const GET_LOSSES_BY_AGENT_URL = `${GET_REPORTS_URL}/losses-by-agent`;
const GET_PLR_URL = `${GET_REPORTS_URL}/policy-loss-run`;
const GET_TAR_FORMS_URL = `${GET_REPORTS_URL}/tran-activity`;
const GET_TAR_URL = `${GET_REPORTS_URL}/transaction-activity`;

// Runtime configuration switchboard (SuperAdmin only). One consolidated place to change live
// settings without a deployment, backed by a per-region DynamoDB table. Report cutover is its
// first category. The constant is named for the path the API actually serves; the UI calls the
// screen Runtime Configuration, and aoc-api-runtime-config-service.js is where the two names
// meet.
const FEATURE_TOGGLES_URL = `${API_BASE_URL}/feature-toggles`;

// Generate Report Endpoints
const GET_ACCOUNT_SUMMARY_GEN_REPORT_URL = `${GET_REPORTS_URL}/account-summary/generate-report`;
const GET_AGENCY_BILLED_STMT_GEN_REPORT_URL = `${GET_REPORTS_URL}/agency-bill-statement/generate-report`;
const GET_APE_GEN_REPORT_URL = `${GET_REPORTS_URL}/ape/generate-report`;
const GET_LOSSES_BY_AGENT_GEN_REPORT_URL = `${GET_REPORTS_URL}/losses-by-agent/generate-report`;
const GET_POLICY_LOSS_RUN_GEN_REPORT_URL = `${GET_REPORTS_URL}/policy-loss-run/generate-report`;
const GET_DIRECT_BILL_COMM_GEN_REPORT_URL = `${GET_REPORTS_URL}/direct-bill-commission/generate-report`;
const GET_BILLING_PAYMENT_GEN_REPORT_URL = `${GET_REPORTS_URL}/billing-payment/generate-report`;
const GET_TAR_GEN_REPORT_URL = `${GET_REPORTS_URL}/transaction-activity/generate-report`;
const GET_BOOK_MGMT_GEN_REPORT_URL = `${GET_REPORTS_URL}/book-management/generate-report`;
const GET_CLAIMS_DETAILS_GEN_REPORT_URL = `${GET_REPORTS_URL}/claims-details/generate-report`;

//
// Bill Payment Endpoints
//
const GET_BILL_PAYMENT_REPORT = `${API_BASE_URL}/reports/bill-payment`;
const GET_BILL_PAYMENT_REPORT_AGENT_CODES = `${GET_BILL_PAYMENT_REPORT}/agent-selections`;
const GET_BILL_PAYMENT_REPORT_AMOUNT_SELECTIONS = `${GET_BILL_PAYMENT_REPORT}/amount-selections`;
const GET_BILL_PAYMENT_REPORT_CONTENTS = `${GET_BILL_PAYMENT_REPORT}/contents`;
const GET_BILL_PAYMENT_REPORT_DATE_SELECTIONS = `${GET_BILL_PAYMENT_REPORT}/date-selections`;
const GET_BILL_PAYMENT_REPORT_EFT = `${GET_BILL_PAYMENT_REPORT}/EFT-selections`;
const GET_BILL_PAYMENT_REPORT_TRANSACTION_TYPES = `${GET_BILL_PAYMENT_REPORT}/trans-selections`;
const GET_BILL_PAYMENT_REPORT_USER_SELECTIONS = `${GET_BILL_PAYMENT_REPORT}/user-selections`;
const GET_BILL_PAYMENT_REPORT_PAYMENT_BALANCE = `${GET_BILL_PAYMENT_REPORT}`;
const GET_BILL_PAYMENT_REPORT_PAYMENT_BALANCE_DETAILS = `${GET_BILL_PAYMENT_REPORT_PAYMENT_BALANCE}/payment-balance-details`;
const GET_BILL_PAYMENT_REPORT_PAYMENT_BALANCE_TOTALS = `${GET_BILL_PAYMENT_REPORT_PAYMENT_BALANCE}/payment-balance-totals`;

//
// Claims Inquiry Endpoints
//
const BASE_CLAIMS_URL = `${API_BASE_URL}/claims-inquiry`;
const POST_CLAIMS_AUTOCOMPLETE = `${BASE_CLAIMS_URL}/auto-completion`;
const GET_CLAIMS_DETAILS = `${BASE_CLAIMS_URL}/details`;
const POST_CLAIMS_SEARCH = `${BASE_CLAIMS_URL}/search`;

//
// Legal Agreement Endpoints
//
const LEGAL_AGREEMENT_ACCEPT = `${API_BASE_URL}/user/accept-legal`;

//
// User Admin Endpoints
//
const USER_ADMIN_ALL_GROUPS = `${API_BASE_URL}/useradm/all-groups`;
const USER_ADMIN_CAN_EDIT = `${API_BASE_URL}/useradm/can-edit`;
const USER_ADMIN_GET_PERMISSION = `${API_BASE_URL}/useradm/permissions/get-permission`;
const USER_ADMIN_GET_USER_INFO = `${API_BASE_URL}/useradm/user-info`;
const USER_ADMIN_GROUP_MEMBERS = `${API_BASE_URL}/useradm/group-members`;
const USER_ADMIN_GROUP_MEMBERS_DETAILS = `${API_BASE_URL}/useradm/group-members-details`;
const USER_ADMIN_SEARCH = `${API_BASE_URL}/useradm/search`;
const USER_ADMIN_PERMITTED_GROUPS = `${API_BASE_URL}/user/permitted-groups`;
const USER_ADMIN_USER_GROUPS = `${API_BASE_URL}/useradm/user-groups`;
const USER_ADMIN_UPDATE_USER_GROUP = `${API_BASE_URL}/useradm/update-user-group`;
const USER_ADMIN_HISTORY = `${API_BASE_URL}/useradm/change-history/for-user`;
const USER_ADMIN_CHALLENGE_QUESTIONS = `${API_BASE_URL}/useradm/challenge-questions`;
const USER_ADMIN_SET_NEW_PASSWORD = `${API_BASE_URL}/useradm/set-new-password`;
const USER_ADMIN_UPDATE_USER = `${API_BASE_URL}/useradm/update-user`;
const USER_ADMIN_CREATE_USER = `${API_BASE_URL}/useradm/create-user`;
const USER_ADMIN_PERMITTED_AGENCY_CODES = `${API_BASE_URL}/user/permitted-agency-codes`;

//
// Redirect constants
//
const REDIRECT_TO_NEW_WINDOW = 0;
const REDIRECT_TO_NEW_TAB = 1;
const REDIRECT_AS_REPLACEMENT = 2;

// Billing payment management history constants
const PAYMENT_MANAGEMENT_HISTORY = `${API_BASE_URL}/payment/management/history`;
const PAYMENT_MANAGEMENT_HISTORY_SELECTIONS = `${API_BASE_URL}/payment/management/history-selections`;
const PAYMENT_MANAGEMENT_HISTORY_BY_DETAIL_ID = `${API_BASE_URL}/payment/management/history/detailById`;

// Billing payment management manage current payment
const PAYMENT_MANAGEMENT_GET_CURRENT_PAYMENTS = `${API_BASE_URL}/payment/management/currentPayments`;
const PAYMENT_MANAGEMENT_UPDATE_CURRENT_PAYMENT = `${API_BASE_URL}/payment/management/updateCurrentPayment`;
const PAYMENT_MANAGEMENT_DELETE_CURRENT_PAYMENT = `${API_BASE_URL}/payment/management/deleteCurrentPayment`;

//Find an agent administration
const SEARCH_AGENT = `${API_BASE_URL}/agentadm/search`;
const UPDATE_AGENT = `${API_BASE_URL}/agentadm/update`;
const ADD_AGENT = `${API_BASE_URL}/agentadm/add`;
const DELETE_AGENT = `${API_BASE_URL}/agentadm/delete`;

export {
  ACCOUNT_NUMBER_URL,
  ADD_AGENT,
  ADD_DOC_NEWS,
  ADD_TEXT_NEWS,
  ADMIN_CHANGE_HISTORY_SEARCH,
  ADMIN_MANAGE_RESOURCES,
  ADMIN_REGIONAL_CONTACTS,
  AGENCY_ADMIN_ADD,
  AGENCY_ADMIN_GET_AVAILABLE_AGENCIES,
  AGENCY_ADMIN_GET_CURRENT_AGENCIES,
  AGENCY_ADMIN_GET_POTENTIAL_AGENCIES,
  AGENCY_ADMIN_GET_SELECTED_AGENCIES,
  AGENCY_ADMIN_PUT_ADD_REMOVE,
  AGENCY_ADMIN_REMOVE,
  AGENCY_ADMIN_SEARCH,
  ALL_STATES_FOR_NEWS,
  AOC_API_HEALTH_CHECK_INITIATE_URL,
  AOC_API_HEALTH_CHECK_LIST_URL,
  AOC_API_HEALTH_CHECK_URL,
  API_BASE_URL,
  BRANDFOLDER_DOCS_PER_PAGE,
  BRANDFOLDER_ORDER_ASSETS,
  BRANDFOLDER_SEARCH,
  BRANDFOLDER_VALIDATIONS,
  DELETE_AGENT,
  DELETE_ARTICLE,
  FEATURE_TOGGLES_URL,
  GET_ABS_REPORT_AGENTS,
  GET_ABS_REPORT_DATES,
  GET_ACCOUNT_SUMMARY_GEN_REPORT_URL,
  GET_AGENCY_BILLED_STMT_GEN_REPORT_URL,
  GET_AGENCY_HAS_MSA_ACCESS,
  GET_AGENCY_SUGGESTIONS,
  GET_ALL_AGENTS,
  GET_ALLOWED_AGENCY_CODES,
  GET_ANNOUNCEMENTS_ITEM,
  GET_ANNOUNCEMENTS_ITEMS,
  GET_ANNOUNCEMENTS_MONTHS,
  GET_ANNOUNCEMENTS_PRODUCTS,
  GET_ANNOUNCEMENTS_STATES,
  GET_ANNOUNCEMENTS_YEARS,
  GET_APE_GEN_REPORT_URL,
  GET_APNE_URL,
  GET_APPETITE,
  GET_APPETITE_HEALTH_CHECK,
  GET_APPETITE_STATES,
  GET_BILL_PAYMENT_REPORT_AGENT_CODES,
  GET_BILL_PAYMENT_REPORT_AMOUNT_SELECTIONS,
  GET_BILL_PAYMENT_REPORT_CONTENTS,
  GET_BILL_PAYMENT_REPORT_DATE_SELECTIONS,
  GET_BILL_PAYMENT_REPORT_EFT,
  GET_BILL_PAYMENT_REPORT_PAYMENT_BALANCE_DETAILS,
  GET_BILL_PAYMENT_REPORT_PAYMENT_BALANCE_TOTALS,
  GET_BILL_PAYMENT_REPORT_TRANSACTION_TYPES,
  GET_BILL_PAYMENT_REPORT_USER_SELECTIONS,
  GET_BILLING_DETAILS,
  GET_BILLING_EXACT_SEARCH,
  GET_BILLING_PAYMENT_ACCOUNTS,
  GET_BILLING_PAYMENT_ADJUSTABLE_PAYMENTS,
  GET_BILLING_PAYMENT_GEN_REPORT_URL,
  GET_BILLING_PAYMENT_NSF_PAYMENTS,
  GET_BILLING_SEARCH,
  GET_BILLING_SEARCH_PAGE_COUNT,
  GET_BILLING_SEARCH_SUGGESTIONS,
  GET_BILLING_SEARCH_V2,
  GET_BMR_URL,
  GET_BOOK_MGMT_GEN_REPORT_URL,
  GET_CL_RENEWALS_DOCUMENTS,
  GET_CL_RENEWALS_LOCATION_THRESHOLD,
  GET_CL_WIP_BASE_URL,
  GET_CL_WIP_PRODUCT_LINES_URL,
  GET_CLAIMS_DETAILS,
  GET_CLAIMS_DETAILS_GEN_REPORT_URL,
  GET_CLIENTS,
  GET_CLIENTS_ACCOUNTS,
  GET_CLIENTS_LOBS,
  GET_CLIENTS_PRODUCTS,
  GET_COMMERCIAL_LINES,
  GET_CONFIGURATION_OKTA,
  GET_DASHBOARD_OPEN_CLAIMS,
  GET_DASHBOARD_OVERDUE_PAYMENTS,
  GET_DASHBOARD_RENEWALS,
  GET_DASHBOARD_UNSOLD_QUOTES,
  GET_DASHBOARD_UNSOLD_QUOTES_STATUS,
  GET_DBC_URL,
  GET_DIRECT_BILL_COMM_GEN_REPORT_URL,
  GET_DOWNLOAD_MEDIA,
  GET_INQUIRE_MSE_POLICY,
  GET_INQUIRE_MSS_POLICY,
  GET_LOSSES_BY_AGENT_GEN_REPORT_URL,
  GET_LOSSES_BY_AGENT_URL,
  GET_NEWS,
  GET_NEWS_ARTICLES,
  GET_OKTA_LOGIN,
  GET_PAYMENTS_DUE_URL,
  GET_PERM_AGENCIES,
  GET_PL_AUTO_COMPLETION_POLICY_ONE_SHIELD,
  GET_PL_POLICIES_ON_NAME,
  GET_PLR_URL,
  GET_POLICY_LOSS_RUN_GEN_REPORT_URL,
  GET_POLICY_NUMBER_SEARCH,
  GET_REDIRECT_URL,
  GET_TAR_FORMS_URL,
  GET_TAR_GEN_REPORT_URL,
  GET_TAR_URL,
  GET_TRANSACTIONS_URL,
  INSURED_LAST_NAME_COUNT_URL,
  INSURED_LAST_NAME_URL,
  LEGAL_AGREEMENT_ACCEPT,
  NEWS_ARTICLES,
  PAYMENT_MANAGEMENT_DELETE_CURRENT_PAYMENT,
  PAYMENT_MANAGEMENT_GET_CURRENT_PAYMENTS,
  PAYMENT_MANAGEMENT_HISTORY,
  PAYMENT_MANAGEMENT_HISTORY_BY_DETAIL_ID,
  PAYMENT_MANAGEMENT_HISTORY_SELECTIONS,
  PAYMENT_MANAGEMENT_UPDATE_CURRENT_PAYMENT,
  POLICY_NUMBER_URL,
  POST_BILLING_PAYMENT,
  POST_BILLING_PAYMENT_ADJUST_PAYMENT,
  POST_BILLING_PAYMENT_POST_PAYMENTS,
  POST_BILLING_PAYMENT_REVERSE_PAYMENT,
  POST_CLAIMS_AUTOCOMPLETE,
  POST_CLAIMS_SEARCH,
  REDIRECT_AS_REPLACEMENT,
  REDIRECT_TO_NEW_TAB,
  REDIRECT_TO_NEW_WINDOW,
  SEARCH_AGENT,
  SESSION_URL,
  UPDATE_AGENT,
  UPDATE_DOC_ARTICLE,
  UPDATE_TEXT_ARTICLE,
  USER_ADMIN_ALL_GROUPS,
  USER_ADMIN_CAN_EDIT,
  USER_ADMIN_CHALLENGE_QUESTIONS,
  USER_ADMIN_CREATE_USER,
  USER_ADMIN_GET_PERMISSION,
  USER_ADMIN_GET_USER_INFO,
  USER_ADMIN_GROUP_MEMBERS,
  USER_ADMIN_GROUP_MEMBERS_DETAILS,
  USER_ADMIN_HISTORY,
  USER_ADMIN_PERMITTED_AGENCY_CODES,
  USER_ADMIN_PERMITTED_GROUPS,
  USER_ADMIN_SEARCH,
  USER_ADMIN_SET_NEW_PASSWORD,
  USER_ADMIN_UPDATE_USER,
  USER_ADMIN_UPDATE_USER_GROUP,
  USER_ADMIN_USER_GROUPS,
};
